<template lang="pug">
  .error-msg-container
    img.logo(
      src="@/umcc/assets/login_logo.png"
    )
    .msg-container
      img(src="@/umcc/assets/msg-error.jpg")
      .content
        div {{ $t('艾漫接口调用错误，创建项目失败，请联系艾漫系统管理员') }}。
        div {{ $t('错误信息') }}：“{{ msg }}”
</template>

<script>
export default {
  mounted () {
    this.msg = this.$route.query.error_msg
  },
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<style lang="stylus">
.error-msg-container
  .logo
    height 50px
    padding 20px
  .msg-container
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top 10%
    flex-direction column
    .content
      font-size 16px
      font-weight: 500
      color #2c3031
      div
        margin-top 30px
</style>
